// extracted by mini-css-extract-plugin
export default {"etablissementInscriptionPage":"EtablissementInscriptionPage_etablissementInscriptionPage__2DRD6"};